import { FC, ReactNode } from 'react';

import { StyledBanner } from './Banner.styles';

export type Props = {
	children?: ReactNode;
	variation: 'warning';
};

const Banner: FC<Props> = ({ children, variation, ...props }) => {
	return (
		<StyledBanner variation={variation} {...props}>
			{children}
		</StyledBanner>
	);
};

export default Banner;
